import { jsx as _jsx } from "react/jsx-runtime";
import cx from '../../utils/classNames';
import styles from './FilterDropdownBasicItem.module.css';
const FilterDropdownBasicItem = ({ className, children, onClick, close, closeOnClick, }) => {
    let _onClick;
    if (onClick !== undefined) {
        _onClick =
            typeof close === 'function' && closeOnClick
                ? () => {
                    close();
                    onClick();
                }
                : onClick;
    }
    else {
        _onClick = typeof close === 'function' && closeOnClick ? close : null;
    }
    return (_jsx("div", Object.assign({ className: cx(styles.root, className), onClick: _onClick }, { children: children }), void 0));
};
export default FilterDropdownBasicItem;
